"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAddress = void 0;
exports.DefaultAddress = '0xcA11bde05977b3631167028862bE2a173976CA11';
